<template>
	<div>
		<!-- Top tabs -->
		<div class="flex xs-right xs-12 bb1 bc7">
			<div class="cu2 c2 fw7 p4 bb2 bc2">
				{{ $t("advanced_view") }}
			</div>
		</div>

		<!-- Case Explorer -->
		<case-explorer />
	</div>
</template>

<script>
import CaseExplorer from "../CaseExplorer/CaseExplorer.vue"

export default {
	components: { CaseExplorer },
	computed: {
		cases() {
			// MOCK:
			return [
				{
					name: "Created",
					value: "01/01/2020"
				},
				{
					name: "Holder (1)",
					// value: "1 item",
					hasUpdate: false,
					hasChildren: true
				},
				{
					name: "Insureds (2)",
					// value: "2 items",
					hasUpdate: false,
					hasChildren: true
				},
				{
					name: "Proposals (3)",
					// value: "3 items",
					hasUpdate: false,
					hasChildren: true
				},
				{
					name: "Facts (34)",
					// value: "34 items",
					hasUpdate: false,
					hasChildren: true
				}
			]

			return this.$store.state.caseMangement.proposals
		},

		insureds() {
			// MOCK:
			return [
				{
					name: "Insured #1",
					// value: "12 fields",
					hasChildren: true
				},
				{
					name: "Insured #2",
					// value: "12 fields",
					hasChildren: true
				}
			]
		},

		insured1Fields() {
			// MOCK:
			return [
				{
					name: "Contacts (3)",
					hasChildren: true
				},
				{
					name: "Identities (2)",
					hasChildren: true
				},
				{
					name: "Addresses (5)",
					hasChildren: true
				},
				{
					name: "Facts (3)",
					hasChildren: true
				}
			]
		},

		contacts() {
			// MOCK:
			return [
				{
					name: "email",
					value: "someth,ing@email.com",
					hasUpdate: true
				},

				{
					name: "telehponeNumber",
					value: "123456789",
					hasUpdate: true
				},
				{
					name: "nameOfTheKeyHere",
					value: "Some value here",
					hasUpdate: true
				}
			]
		},

		mainFields() {
			// MOCK:
			return [
				{
					name: "Product"
				},
				{
					name: "Premium"
				},
				{
					name: "Holder"
				},
				{
					name: "Other Holder 1"
				},
				{
					name: "Insured 1"
				},
				{
					name: "Insured 2"
				},
				{
					name: "Insured 3"
				},
				{
					name: "Insured 4"
				},
				{
					name: "Case Facts"
				},
				{
					name: "Proposal Credentials"
				},
				{
					name: "Proposal Facts"
				},
				{
					name: "Offer Credentials"
				},
				{
					name: "Offer Facts"
				}
			]
		},

		allFields() {
			// MOCK:
			return [
				{
					type: "nameOfTheKeyHere",
					value: "Some value here"
				},
				{
					type: "nameOfTheKeyHere",
					value: "Some value here"
				},
				{
					type: "nameOfTheKeyHere",
					value: "Some value here"
				},
				{
					type: "nameOfTheKeyHere",
					value: "Some value here"
				}
			]
		}
	}
}
</script>
